// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"labels__wrapper___Yd44u","label":"labels__label___3OeuW","icon":"labels__icon___3dRXQ"};
    if(module.hot) {
      // 1745801682457
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  